import { lazy } from '@/service/lazy'
import token from './token'

export default [{
  name: 'Promotora',
  path: '*',
  component: lazy('app/auth/login/index'),
  children: [
    ...token
  ]
}]



// WEBPACK FOOTER //
// ./src/router/modules/auth/promotora.js